<template>
    <div class="badge-filter" data-testid="badges-filter">
        <VJoyCheckbox
            v-for="badge in availableSearchFilters?.badges"
            :key="badge.key"
            :checked="isCheckedFilter(badge.key as RetrieveAvailableFiltersBadgeEnum)"
            :data-testid="`badges-filter-${badge.key}`"
            @update:checked="toggleBadgeParam(badge.key as RetrieveAvailableFiltersBadgeEnum)"
        >
            <VJoyBadgeLevel v-if="badge.key === 'SUPER_MALTER'" type="supermalter" />
            <span v-else>{{ badge.label }}</span>
            &nbsp;({{ badge.count }})
            <p class="badge-filter__text">
                {{ $t(`search.filters.${badge.key}.label` as TranslationKey) }}
                <br />
                <a :href="$t(`search.filters.${badge.key}.more.link` as TranslationKey)" target="_blank">
                    {{ $t(`search.filters.${badge.key}.more` as TranslationKey) }}
                </a>
            </p>
        </VJoyCheckbox>
    </div>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyBadgeLevel, VJoyCheckbox} from '@maltjoy/core-vue';
    import type {RetrieveAvailableFiltersBadgeEnum} from '@api';
    import {useFiltersStore} from '../stores/filters.store';
    import type {TranslationKey} from '#build/i18n';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    function toggleBadgeParam(badgeKey: RetrieveAvailableFiltersBadgeEnum) {
        filtersStore.toggleBadgeFilter(badgeKey);
    }

    function isCheckedFilter(badgeKey: RetrieveAvailableFiltersBadgeEnum) {
        return filtersStore.isBadgeChecked(badgeKey);
    }
</script>
<style scoped lang="scss">
    .badge-filter__text {
        margin: var(--joy-core-spacing-2) 0 0;
        font-size: var(--joy-font-size-primary-200);
    }
</style>
